import axiosInstance from '../../../api/axiosConfig';

export const dashboardService = {
  getStats: async () => {
    try {
      const res = await axiosInstance.get('/dashboard/stats');
      return res.data?.data ?? {
        users: { total: 0, subtitle: 'Usuarios registrados' },
        companies: { total: 0, subtitle: 'Empresas activas' },
        proceedings: { total: 0, subtitle: 'Expedientes totales' },
        correspondence: { total: 0, subtitle: 'Correspondencias' },
        documents: { total: 0, subtitle: 'Documentos en expedientes y correspondencias' },
      };
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      return {
        users: { total: 0, subtitle: 'Usuarios registrados' },
        companies: { total: 0, subtitle: 'Empresas activas' },
        proceedings: { total: 0, subtitle: 'Expedientes totales' },
        correspondence: { total: 0, subtitle: 'Correspondencias' },
        documents: { total: 0, subtitle: 'Documentos en expedientes y correspondencias' },
      };
    }
  },
};
